<template>
  <BaseLayout>
    <template v-slot:top_buttons>
      <div v-click-outside="closeAddButtons">
        <button type="button" class="btn btn-primary" @click="showAddButtons = !showAddButtons">
          Добавить магазин
        </button>
        <div class="dropdown-menu" aria-labelledby="btnGroupDrop1" :class="showAddButtons ? 'show' : ''">
          <a class="dropdown-item" href="javascript:void(0);" @click="createStore('ozon')">Озон</a>
          <a class="dropdown-item" href="javascript:void(0);" @click="createStore('wb')">Wildberries</a>
          <a class="dropdown-item" href="javascript:void(0);" @click="createStore('yandex')">Яндекс Маркет</a>
        </div>
      </div>
    </template>

    <OffCanvas ref="storeOffCanvas" :title="modalTitle" :width="600">
      <component v-if="marketplace_form" :is="marketplace_form" v-bind="marketplace_props"
                 @store-success="storeSuccess"
                 ref="MarketPlaceForm"></component>
    </OffCanvas>

    <LoadingBlock :loading="loadingStores">
      <!-- Блок когда магазинов нет -->
      <div v-if="!loadingStores && stores.length === 0" class="text-center py-5">
        <div class="card mx-auto shadow-sm" style="max-width: 700px;">
          <div class="card-body p-5">
            <div class="mb-4">
              <i class="ti ti-store text-primary mb-3" style="font-size: 5rem; opacity: 0.8;"></i>
            </div>
            <h3 class="mb-4 text-dark">Добро пожаловать в Kindata.Profit!</h3>
            
            <div class="mb-4">
              <p class="fs-5 text-muted mb-3 lh-base">
                Для начала работы необходимо подключить ваш первый магазин
              </p>
              
              <p class="text-muted mb-3 lh-base">
                Вы можете добавить <strong>несколько магазинов с одного маркетплейса</strong> 
                (количество зависит от выбранного тарифного плана)
              </p>
            </div>

            <div class="mb-4">
              <div class="">
                <strong>Поддерживаемые маркетплейсы:</strong>
              </div>
              <div class="d-flex justify-content-center gap-4 flex-wrap">
                <div class="d-flex align-items-center">
                  <i class="ti ti-building-store text-primary me-2"></i>
                  <span class="fw-medium">Озон (схемы FBS и FBO)</span>
                </div>
                <div class="d-flex align-items-center">
                  <i class="ti ti-building-store text-primary me-2"></i>
                  <span class="fw-medium">Wildberries (FBS и FBW)</span>
                </div>
                <div class="d-flex align-items-center">
                  <i class="ti ti-building-store text-primary me-2"></i>
                  <span class="fw-medium">Яндекс Маркет (FBS)</span>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <DocLink docKey="getting_started" text="Посмотреть инструкцию" />
            </div>
            <div class="mb-4" v-if="isJivoEnabled">
              <p class="text-muted mb-0">
                Нужна помощь с настройкой?
                <a href="javascript:void(0);" class="text-primary text-decoration-none ms-1" @click.prevent="openSupport">
                  <i class="ti ti-headset me-1"></i>
                  Написать в поддержку
                </a>
              </p>
            </div>
            <div v-click-outside="closeEmptyStateButtons" class="position-relative d-inline-block">
              <button type="button" class="btn btn-primary btn-lg px-4 py-3" @click="showEmptyStateButtons = !showEmptyStateButtons">
                <i class="ti ti-plus me-2"></i>
                Подключить первый магазин
              </button>
              <div class="dropdown-menu shadow" :class="showEmptyStateButtons ? 'show' : ''" style="position: absolute; top: 100%; left: 50%; transform: translateX(-50%); z-index: 1000; min-width: 200px;">
                <a class="dropdown-item py-3" href="javascript:void(0);" @click="createStore('ozon')">
                  <i class="ti ti-building-store text-primary me-3"></i>
                  <strong>Озон</strong>
                </a>
                <a class="dropdown-item py-3" href="javascript:void(0);" @click="createStore('wb')">
                  <i class="ti ti-building-store text-primary me-3"></i>
                  <strong>Wildberries</strong>
                </a>
                <a class="dropdown-item py-3" href="javascript:void(0);" @click="createStore('yandex')">
                  <i class="ti ti-building-store text-primary me-3"></i>
                  <strong>Яндекс Маркет</strong>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Существующий список магазинов -->
      <div v-else class="row mb-12 g-6">
        <div class="col-md-6 col-lg-4" v-for="(store, index) in stores" :key="index">
          <div class="card">
            <div class="card-header pb-0 d-flex justify-content-between">
              <h5 class="card-title">{{ store.name }}</h5>
              <DropdownComponent>
                <a class="dropdown-item waves-effect" href="javascript:void(0);" @click="openTasks(store.id)">Список задач</a>
              </DropdownComponent>
            </div>
            <div class="card-body">
              <p class="card-text">Маркетплейс: {{ marketplaces[store.marketplace].title }}</p>
              <div class="demo-inline-spacing">
                <button class="btn btn-outline-secondary waves-effect" @click="editStore(store.marketplace, store.id)">
                  Редактировать
                </button>
              </div>
              <div class="demo-inline-spacing">
                <ButtonComponent :ref="'deleteStoreButton'+index" :class="'btn btn-outline-danger waves-effect'"
                                 @click="deleteStore(store.id, 'deleteStoreButton'+index)">Удалить
                </ButtonComponent>
                <ButtonComponent :ref="'importButton'+index" :class="'btn btn-outline-secondary waves-effect'"
                                 @click="storeImport(store.id, 'importButton'+index)">Импорт товаров
                </ButtonComponent>
                <ButtonComponent :ref="'getOffersButton'+index" :class="'btn btn-outline-secondary waves-effect'"
                                 @click="storeGetOffers(store.id, 'getOffersButton'+index)">Загрузка цен из магазина
                </ButtonComponent>
                <ButtonComponent :ref="'getOrderButton'+index" :class="'btn btn-outline-secondary waves-effect'"
                                 @click="storeGetOrders(store.id, 'getOrderButton'+index)">Загрузка заказов
                </ButtonComponent>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingBlock>
    <StoreTasks ref="StoreTasks" :store_id="tasks_store_id"></StoreTasks>
  </BaseLayout>
</template>

<script>
import BaseLayout from "@/layouts/Base.vue";
import {PageInfo} from "@/data/page";
import {user} from "@/data/user";
import {
  deleteStore,
  getStoreOzone,
  getStores,
  getStoreWb,
  importProducts,
  getOffers,
  getStoreYandex,
  getOrders
} from "@/api/store";
import {VOnClickOutside as ClickOutside} from "@/helpers/directives/clickOutside"
import OffCanvas from "@/components/page/OffCanvas.vue";
import OzonForm from "@/components/forms/Ozon.vue";
import WbForm from "@/components/forms/Wb.vue";
import YandexForm from "@/components/forms/Yandex.vue";
import {shallowRef} from "vue";
import ButtonComponent from "@/components/tools/Button.vue";
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import {afterStoreAction} from "@/helpers/store";
import {stores} from "@/data/store";
import DropdownComponent from "@/components/tools/Dropdown.vue";
import StoreTasks from "@/components/store/Tasks.vue";
import DocLink from "@/components/tools/DocLink.vue";
import {isJivoEnabled, openJivoChat} from "@/utils/jivo";

const marketplaces = {
  ozon: {
    form: OzonForm,
    api: getStoreOzone,
    title: 'Озон'
  },
  wb: {
    form: WbForm,
    api: getStoreWb,
    title: 'Wildberries'
  },
  yandex: {
    form: YandexForm,
    api: getStoreYandex,
    title: 'Яндекс Маркет'
  }
}

export default {
  name: 'StoresView',
  components: {StoreTasks, DropdownComponent, LoadingBlock, ButtonComponent, OffCanvas, BaseLayout, DocLink},
  data() {
    return {
      showAddButtons: false,
      showEmptyStateButtons: false,
      stores: [],
      marketplace_form: '',
      marketplace_props: {},
      modalTitle: 'Новый магазин',
      marketplaces: marketplaces,
      loadingStores: true,
      tasks_store_id: ''
    }
  },
  directives: {
    ClickOutside
  },
  computed: {
    isJivoEnabled() {
      return isJivoEnabled()
    }
  },
  methods: {
    openSupport() {
      openJivoChat()
    },
    closeAddButtons() {
      this.showAddButtons = false
    },
    closeEmptyStateButtons() {
      this.showEmptyStateButtons = false
    },
    async createStore(marketplace) {
      this.marketplace_form = ''
      this.modalTitle = 'Новый магазин'
      // Закрываем дропдауны
      this.showAddButtons = false
      this.showEmptyStateButtons = false
        
      setTimeout(() => {
        this.$refs.storeOffCanvas.open()
        this.marketplace_props = {'item': ''}
        this.marketplace_form = shallowRef(marketplaces[marketplace].form)
      }, 100)
    },
    async editStore(marketplace, store_id) {
      this.marketplace_form = ''
      this.modalTitle = 'Редактировать магазин'
      setTimeout(async () => {
        this.$refs.storeOffCanvas.open()
        const result = await marketplaces[marketplace].api(store_id)
        this.marketplace_props = {'item': result.data}
        this.marketplace_form = shallowRef(marketplaces[marketplace].form)
      })
    },
    async deleteStore(store_id, button) {
      if (confirm('Вы уверены, что хотите удалить магазин?')) {
        this.$refs[button][0].startLoading()
        await deleteStore(store_id)
        this.$refs[button][0].endLoading()
        await this.updateStores()
        stores.resetStores()
      }
    },
    async storeImport(store_id, button) {
      if (confirm('Вы уверены, что хотите импортировать товары из магазина?')) {
        this.$refs[button][0].startLoading()
        try {
          const result = await importProducts(store_id)
          afterStoreAction(result)
        } catch (exception) {
          afterStoreAction(exception.response)
        }
        this.$refs[button][0].endLoading()
      }
    },
    async storeGetOffers(store_id, button) {
      if (confirm('Вы уверены, что хотите обновить цены?')) {
        this.$refs[button][0].startLoading()
        try {
          const result = await getOffers(store_id)
          afterStoreAction(result)
        } catch (exception) {
          afterStoreAction(exception.response)
        }
        this.$refs[button][0].endLoading()
      }
    },
    async storeGetOrders(store_id, button) {
      if (confirm('Вы уверены, что хотите загрузить заказы?')) {
        this.$refs[button][0].startLoading()
        try {
          const result = await getOrders(store_id)
          afterStoreAction(result)
        } catch (exception) {
          afterStoreAction(exception.response)
        }
        this.$refs[button][0].endLoading()
      }
    },
    async updateStores() {
      this.loadingStores = true
      const active_company = await user.getActiveCompany()
      const result = await getStores(active_company, 1, 10000)
      this.stores = result.data.items
      this.loadingStores = false
    },
    async storeSuccess() {
      this.$refs.storeOffCanvas.close()
      await this.updateStores()
      await stores.updateStores()
    },
    async openTasks(store_id) {
      this.tasks_store_id = store_id;
      this.$refs.StoreTasks.open()
    }
  },
  async mounted() {
    PageInfo.title = 'Магазины'
    PageInfo.breadcrumbs = [
      {
        title: 'Главная',
        link: '/'
      },
      {
        title: PageInfo.title
      }
    ]
    await user.getUserBase()
    await this.updateStores()
  }
}
</script>